import React from 'react';
import { format, startOfWeek, endOfWeek } from 'date-fns';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const NavigationHeader = ({
  currentDate,
  onPrevWeek,
  onNextWeek,
  onNavigateToToday
}) => {
  const isCurrentWeek = format(
    startOfWeek(currentDate, { weekStartsOn: 1 }),
    'yyyy-MM-dd'
  ) === format(
    startOfWeek(new Date(), { weekStartsOn: 1 }),
    'yyyy-MM-dd'
  );

  const getDateRange = () => {
    const weekStart = startOfWeek(currentDate, { weekStartsOn: 1 });
    const weekEnd = endOfWeek(currentDate, { weekStartsOn: 1 });
    return `${format(weekStart, 'MMM d')} - ${format(weekEnd, 'MMM d, yyyy')}`;
  };

  return (
    <div className="flex items-center justify-between w-full px-3 sm:px-4 py-2 bg-gray-800 rounded-xl">
      {/* LEFT: Previous Week Button (ALWAYS LEFTMOST) */}
      <button
        onClick={onPrevWeek}
        className="min-w-[44px] min-h-[44px] flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-700 hover:text-white active:bg-gray-700/70 transition-colors"
        aria-label="Previous week"
      >
        <ChevronLeftIcon className="h-5 w-5 sm:h-6 sm:w-6" />
      </button>

      {/* CENTER: Clickable Date Range (PERFECTLY CENTERED) */}
      <div 
        onClick={isCurrentWeek ? undefined : onNavigateToToday}
        className={`flex-1 flex flex-col items-center justify-center ${
          isCurrentWeek 
            ? 'text-white cursor-default' 
            : 'text-gray-300 hover:text-blue-300 cursor-pointer transition-colors'
        }`}
        aria-label={isCurrentWeek ? "Current week" : "Click to view current week"}
      >
        <h2 className="text-base sm:text-lg font-semibold text-center">
          {getDateRange()}
        </h2>
        {!isCurrentWeek && (
          <p className="text-sm text-gray-400 hover:text-blue-400 transition-colors text-center">
            Click to view current week
          </p>
        )}
      </div>

      {/* RIGHT: Next Week Button (ALWAYS RIGHTMOST) */}
      <button
        onClick={onNextWeek}
        className="min-w-[44px] min-h-[44px] flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-700 hover:text-white active:bg-gray-700/70 transition-colors"
        aria-label="Next week"
      >
        <ChevronRightIcon className="h-5 w-5 sm:h-6 sm:w-6" />
      </button>
    </div>
  );
};

export default NavigationHeader;